<template>
  <div id="chart">
    <apexchart
      type="line"
      :height="height || '350vh'"
      :options.sync="chartOptions"
      :series="series"
    />
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'GraphicArea',
  props: [
    'sensores',
    'tipo',
    'range',
    'maxValue',
    'minValue',
    'showMarker',
    'height',
  ],
  data() {
    return {
      timeOffset: new Date().getTimezoneOffset() * 1000 * 60,
      series: [],
      chartOptions: {
        colors: [
          '#008FFB',
          '#00E396',
          '#FEB019',
          '#FF4560',
          '#775DD0',
          '#966e23',
          '#ff07dd',
          '#4af0ff',
          '#000dff',
          '#3f3f3f',
        ],
        markers: {
          size: this.showMarker ? 4 : 0,
        },
        chart: {
          type: 'line',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 2,
          curve: 'straight',
        },
        title: {
          text: `${this.tipo}`,
          align: 'left',
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          type: 'datetime',
          labels: {
            formatter: (value, timestamp) => {
              let format = 'HH:mm'

              if (this.maxValue && this.minValue) {
                format = 'HH:mm DD/MM'
              }

              return moment(new Date(timestamp)).format(format)
            },
          },
          max: this.maxValue || new Date().getTime(),
          range: this.range || 1000 * 60 * 60 * 2,
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val.toFixed(2)
            },
          },
          tickAmount: 5,
          min: 0,
          max: undefined,
        },
      },
    }
  },
  beforeMount() {
    this.init()

    this.chartOptions.yaxis.max = this.series.every((e) =>
      e.data.every((s) => s[1] === 0)
    )
      ? 100
      : (x) => x
  },
  methods: {
    init() {
      this.sensores.forEach((e) => {
        this.series.push({
          name: `${e.descricao}`,
          data: e.dados,
        })
      })
    },
  },
}
</script>

<style scoped></style>
